import * as React from "react"
import { MainNav } from "@/components/MainNav"
import { VerificationBanner } from "@/components/VerificationBanner"
import { GuestQuizClaimBanner } from "@/components/GuestQuizClaimBanner"

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav />
      <div className="min-w-0 flex-1 flex flex-col">
        <VerificationBanner />
        <GuestQuizClaimBanner />
        <main className="flex-1 px-6 py-8 sm:px-10">
          <div className="mx-auto max-w-4xl">{children}</div>
        </main>
      </div>
    </div>
  )
}
